module.exports = __webpack_public_path__ + "media/banner-switch.b3381fb8.mp3";